import { Box, Grid, Tab, Tabs } from "@mui/material"
import React, { useState } from "react"
import LayoutPage from "src/components/page-layout/layout-page"
import AlertMessage from "src/components/alert-message"
import RaterConsultadeDados from "./subpages/RaterConsultadeDados"
import RaterMapeamento from "./subpages/RaterMapeamento"
import RaterMetricas from "./subpages/RaterMetricas"
import RaterModelos from "./subpages/RaterModelos"
import RaterRotinas from "./subpages/RaterRotinas"

const ConfiguracoesRaterPage = () => {
    const tabs = [
        { id: 0, description: "Modelos" },
        { id: 1, description: "Métricas" },
        { id: 2, description: "Mapeamento" },
        { id: 3, description: "Rotinas" },
        { id: 4, description: "Consulta de Dados" },
    ]

    const [selectedTab, setSelectedTab] = useState(0)
    const [loading, setLoading] = useState(false)
    const [alertMessageState, setAlertMessageState] = React.useState({
        open: false,
        message: "",
        type: ""
    })

    const openAlert = (message, type) => {
        setAlertMessageState({
            ...alertMessageState,
            open: true,
            message: message,
            type: type
        })
    }

    const closeAlert = () => {
        setAlertMessageState({ ...alertMessageState, open: false })
    }

    const handleChange = (_event, newValue) => {
        setSelectedTab(newValue)
    }

    const renderContent = () => {
        switch (selectedTab) {
            case 0:
                return (
                    <>
                        <RaterModelos  loading={setLoading} alert={openAlert} />
                    </>
                )
            case 1:
                return (
                    <>
                        <RaterMetricas  loading={setLoading} alert={openAlert} />
                    </>
                )
            case 2:
                return (
                    <>
                        <RaterMapeamento loading={setLoading} alert={openAlert} />
                    </>
                )
            case 3:
                return (
                    <>
                        <RaterRotinas  loading={setLoading} alert={openAlert} />
                    </>
                )
            case 4:
                return (
                    <>
                        <RaterConsultadeDados RaterRotinas loading={setLoading} alert={openAlert} />
                    </>
                )
            default:
                return null
        }
    }

    return (
        <LayoutPage title="Configurações Rater" loading={loading}>
            <AlertMessage open={alertMessageState.open} message={alertMessageState.message} type={alertMessageState.type} close={closeAlert} />
            <Box
                sx={{
                    borderBottom: 1,
                    borderColor: 'divider',
                    height: "100vh",
                    display: "flex",
                    flexDirection: "column"
                }}>
                
                <Tabs value={selectedTab} onChange={handleChange} aria-label="tabs">
                    {tabs.map((tab) => (
                        <Tab label={tab.description} key={tab.id} />
                    ))}
                </Tabs>

                <Box
                    sx={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                    }}>
                    <Grid
                        container
                        direction="row"
                        alignContent="flex-start"
                        justifyContent="flex-start"
                        spacing={0}
                        sx={{
                            padding: 2,
                            height: "100%", // altura de 100% da Box
                        }}>
                        <Grid item xs={12} sm={12} md={12} xl={12} sx={{ height: "100%" }}>
                        {renderContent()}
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </LayoutPage>
    )
}

export default ConfiguracoesRaterPage